export default {
    data: () => ({
        translations: {
            publicApiTitle: {
                el: "Public API",
                en: "Public API",
                it: "Public API"
            },
            publicApiDescription: {
                el: "Χρησιμοποίησε το documentation για να χρησιμοποιήσεις το RoadCube API. Πρόσθεσε IPs στο whitelist για να περιορίσεις την πρόσβαση μόνο σε αυτές. Αν δεν υπάρχει καμία IP, το API είναι ανοιχτό για όλους.",
                en: "Use the documentation to use the RoadCube API. Add IPs to the whitelist to restrict access to only those. If there are no IPs, the API is open to everyone.",
                it: "Utilizza la documentazione per utilizzare l'API RoadCube. Aggiungi IP alla whitelist per limitare l'accesso solo a questi. Se non ci sono IP, l'API è aperta a tutti."
            },
            whitelistTitle: {
                el: "IP Whitelist",
                en: "IP Whitelist",
                it: "IP Whitelist"
            },
            addIp: {
                el: "Προσθήκη IP",
                en: "Add IP",
                it: "Aggiungi IP"
            },
            title: {
                el: "Τίτλος",
                en: "Title",
                it: "Titolo"
            },
            titlePlaceholder: {
                el: "π.χ. Γραφείο Θεσσαλονίκης",
                en: "e.g. Thessaloniki office",
                it: "es. Ufficio di Salonicco"
            },
            ip: {
                el: "IP",
                en: "IP",
                it: "IP"
            },
            ipPlaceholder: {
                el: "π.χ. 192.168.1.1",
                en: "e.g. 192.168.1.1",
                it: "es. 192.168.1.1"
            },
            actions: {
                el: "Ενέργειες",
                en: "Actions",
                it: "Azioni"
            },
            edit: {
                el: "Επεξεργασία",
                en: "Edit",
                it: "Modifica"
            },
            delete: {
                el: "Διαγραφή",
                en: "Delete",
                it: "Elimina"
            },
            save: {
                el: "Αποθήκευση",
                en: "Save",
                it: "Salva"
            },
            cancel: {
                el: "Ακύρωση",
                en: "Cancel",
                it: "Annulla"
            },
            empty: {
                el: "Καμία IP στο whitelist. Το API είναι ανοιχτό για όλους.",
                en: "No IPs in the whitelist. The API is open to everyone.",
                it: "Nessun IP nella whitelist. L'API è aperta a tutti."
            },
            invalidIp: {
                el: "Μη έγκυρη διεύθυνση IP",
                en: "Invalid IP address",
                it: "Indirizzo IP non valido"
            },
            ipRequired: {
                el: "Η IP είναι υποχρεωτική",
                en: "IP is required",
                it: "L'IP è obbligatorio"
            },
            titleRequired: {
                el: "Ο τίτλος είναι υποχρεωτικός",
                en: "Title is required",
                it: "Il titolo è obbligatorio"
            },
            success: {
                el: "Επιτυχής αποθήκευση",
                en: "Saved successfully",
                it: "Salvato con successo"
            },
            deleted: {
                el: "Διαγράφηκε επιτυχώς",
                en: "Deleted successfully",
                it: "Eliminato con successo"
            },
            error: {
                el: "Κάτι πήγε στραβά",
                en: "Something went wrong",
                it: "Qualcosa è andato storto"
            },
            confirmDelete: {
                el: "Είσαι σίγουρος ότι θέλεις να διαγράψεις αυτή την IP;",
                en: "Are you sure you want to delete this IP?",
                it: "Sei sicuro di voler eliminare questo IP?"
            }
        }
    })
};
